export const BASE_URL = "https://backend-dave-space.onrender.com";
// export const BASE_URL = "http://localhost:5500";
